// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__38Zl5","logo__link":"Logo_logo__link__1BR1D","copyright":"Logo_copyright__1ZNbK"};